import styled, { keyframes } from 'styled-components'

import { atMd, fromLg, untilMd } from '@syconium/little-miss-figgy'

export const PageWrapper = styled.div`
  height: auto;

  ${fromLg} {
    height: 560vh;
    position: relative;
  }
`

export const PageContent = styled.div<{
  isFixed: number
}>`
  position: relative;

  ${fromLg} {
    transition: all 0.3s ease-in-out;
    position: ${i => (i.isFixed <= 0 ? 'fixed' : 'absolute')};
    top: ${i => (i.isFixed >= 0 ? 'auto' : 0)};
    bottom: ${i => (i.isFixed >= 0 ? 0 : 'auto')};
  }
`

export const Body = styled.div`
  padding: 0 24px;
  display: flex;
  justify-content: center;
  border-bottom: none;
  margin-bottom: -3px;

  ${fromLg} {
    padding: 0 80px;
  }

  ${atMd} {
    display: block;
  }

  ${untilMd} {
    display: inline-grid;
    padding: 0;
  }
`

export const TitleWrapper = styled.div`
  display: inline-grid;
  align-content: center;

  ${atMd} {
    width: 100%;
    margin: 48px 0;
    text-align: center;
  }

  ${fromLg} {
    max-width: 369px;
  }

  ${untilMd} {
    width: 100%;
    margin-bottom: 48px;
  }
`

export const StoreBtnWrapper = styled.div`
  display: flex;
  justify-content: center;
  padding-top: 20px;

  ${fromLg} {
    display: none;
  }
`

export const Title = styled.div<{
  titleLetterSpacing?: number
}>`
  font-size: 24px;
  text-transform: uppercase;
  font-weight: 700;
  letter-spacing: ${o => o.titleLetterSpacing || '5.4'}px;
  text-align: center;
  padding-bottom: 10px;

  ${fromLg} {
    font-size: 36px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: ${o => o.titleLetterSpacing || '5.4'}px;
    text-align: left;
  }
  ${atMd} {
    font-size: 28px;
    text-transform: uppercase;
    font-weight: 700;
    letter-spacing: 4.4px;
  }
`

export const Subtitle = styled.div`
  font-size: 22px;
  letter-spacing: 1.1px;
  line-height: 36px;

  ${atMd} {
    font-size: 16px;
    line-height: 27px;
  }

  ${untilMd} {
    text-align: center;
    padding: 16px 25px 0 25px;
  }
`

export const QrWrapper = styled.div`
  padding-top: 40px;
  max-width: 240px;
  display: none;
  ${fromLg} {
    display: block;
  }
`

export const QrTitle = styled.div`
  padding-top: 40px;
  font-size: 13px;
  letter-spacing: 0.6px;
  line-height: 22px;
`

export const QrCode = styled.div`
  margin-top: 26px;
  height: 140px;
  width: 140px;
  margin-left: -10px;
`

export const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  padding-top: 37px;

  ${fromLg} {
    max-width: 478.39px;
  }
  ${atMd} {
    max-width: 478.39px;
  }
  ${untilMd} {
    margin-left: -9%;
    position: relative;
  }
`

export const ImagePopUpWrapper = styled.div`
  position: relative;
`

export const PopUpWrapperAnimation = keyframes`
  0% {
    opacity: 0;
    transform: scale(.3);
  }
  50% {
    opacity: 1;
    transform: scale(1.20);
  }
  70% {
    transform: scale(.9);
  }
  100% {
    transform: scale(1);
  }
`

/* TODO: Fix this auto suppressed ESLint rule */
/* eslint-disable-next-line rulesdir/require-responsive-images */
export const PopUpWrapper = styled.img<{
  maxWidth?: string
  top?: string
  bottom?: string
  left?: string
  right?: string
  width?: string
}>`
  position: absolute;
  top: ${o => o.top};
  width: ${o => o.width};
  bottom: ${o => o.bottom};
  left: ${o => o.left};
  right: ${o => o.right};
  max-width: ${o => o.maxWidth};
  animation-name: ${PopUpWrapperAnimation};
  animation-duration: 0.5s;
  ${untilMd} {
    transform: scale(0.6);
    animation-duration: 0s;
  }
`

export const DesktopViewWrapper = styled.div`
  display: flex;

  ${untilMd} {
    display: none;
  }
`
